import { useShop } from "@/context/ShopContext";
import { formatRupiah, formatTanggal } from "@/lib/format";
import { Receipt, History } from "lucide-react";

export default function Riwayat() {
  const { transactions } = useShop();

  return (
    <div className="flex flex-col h-full overflow-y-auto">
      <div className="px-8 pt-8 pb-4">
        <h2 className="font-heading font-bold text-2xl text-slate-900">Riwayat Transaksi</h2>
        <p className="text-sm text-slate-500 mt-1">{transactions.length} transaksi tercatat</p>
      </div>

      <div className="px-8 pb-8 space-y-4" data-testid="list-riwayat">
        {transactions.length === 0 && (
          <div className="bg-white rounded-xl border border-slate-200 flex flex-col items-center justify-center py-20 text-slate-400">
            <History className="w-12 h-12 mb-3" strokeWidth={1.3} />
            <p>Belum ada transaksi</p>
          </div>
        )}

        {transactions.map((trx) => (
          <div
            key={trx.id}
            data-testid={`riwayat-${trx.id}`}
            className="bg-white rounded-xl border border-slate-200 shadow-[0_2px_10px_rgba(0,0,0,0.04)] p-6"
          >
            <div className="flex items-center justify-between flex-wrap gap-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center">
                  <Receipt className="w-5 h-5 text-blue-600" />
                </div>
                <div>
                  <p className="font-heading font-bold text-slate-900">{formatRupiah(trx.total)}</p>
                  <p className="text-xs text-slate-500">{formatTanggal(trx.created_at)}</p>
                </div>
              </div>
              <div className="flex gap-6 text-right">
                <div>
                  <p className="text-xs text-slate-400">Modal</p>
                  <p className="text-sm font-semibold text-slate-700">{formatRupiah(trx.total_modal)}</p>
                </div>
                <div>
                  <p className="text-xs text-slate-400">Laba</p>
                  <p className="text-sm font-bold text-emerald-600">{formatRupiah(trx.total_laba)}</p>
                </div>
              </div>
            </div>

            <div className="mt-4 pt-4 border-t border-slate-100 flex flex-wrap gap-2">
              {trx.items.map((it, i) => (
                <span key={i} className="text-xs bg-slate-50 border border-slate-100 rounded-lg px-3 py-1.5 text-slate-600">
                  {it.nama} <span className="font-semibold text-slate-900">x{it.jumlah}</span>
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
